module.exports = __webpack_public_path__ + "static/img/customercase6.efddc77.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/customercase/customercase6.png
// module id = yJl5
// module chunks = 0